export var CurrencyType;
(function (CurrencyType) {
    CurrencyType["PL"] = "pl-PL";
    CurrencyType["FI"] = "fi-FI";
    CurrencyType["LT"] = "lt-LT";
    CurrencyType["LV"] = "lv-LV";
    CurrencyType["EE"] = "et-EE";
    CurrencyType["CO"] = "es-CO";
    CurrencyType["CL"] = "es-CL";
    CurrencyType["AR"] = "es-AR";
    CurrencyType["PE"] = "es-PE";
    CurrencyType["SG"] = "en-SG";
    CurrencyType["CR"] = "es-CR";
    CurrencyType["PA"] = "es-PA";
})(CurrencyType || (CurrencyType = {}));
//# sourceMappingURL=CurrencyType.js.map